import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineSmileIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M14.36 14.23a3.7598 3.7598 0 0 1-4.72 0 1.0013 1.0013 0 0 0-1.28 1.54 5.68 5.68 0 0 0 7.28 0 1.0014 1.0014 0 0 0-.5481-1.767 1.0013 1.0013 0 0 0-.7319.227ZM9 11a1.0006 1.0006 0 0 0 .9239-.6173.9998.9998 0 0 0-.7288-1.3635A1 1 0 1 0 9 11Zm6-2a1.0002 1.0002 0 0 0-.9808 1.1951.9995.9995 0 0 0 .7857.7857A.9998.9998 0 0 0 16 10a1.0002 1.0002 0 0 0-1-1Zm-3-7a10 10 0 1 0 0 20.0001A10 10 0 0 0 12 2Zm0 18a8.0005 8.0005 0 0 1-7.391-4.9385A8 8 0 1 1 12 20Z"/>
  </SvgIcon>
}

export default LineSmileIcon
